/**
 * 
 * @param {array[string]} userStepPermissions - generated by CompletionStepPermissionsUtil
 * @param {object} completionStep 
 * @param {string} taskStatus - should be of the format 'in_progress' etc.
 */
function canUserEditPhoto(userStepPermissions, completionStep, task) {
  return (
    (completionStep && userStepPermissions && userStepPermissions.has('photo_upload')) && 
    (
      (completionStep.status == 'approved' && task.status == 'in_progress') ||
      ((completionStep.status == 'completed' || completionStep.status == 'complete') && task.status == 'in_progress') ||
      ((completionStep.status == 'completed' || completionStep.status == 'complete') && task.status == 'pending_review') ||
      (completionStep.status == 'pending_review' || completionStep.status == 'rejected') ||
      (completionStep.status == 'pending_approval' && !completionStep.reviewed_at) ||
      (task.status == 'completed' && !task.has_approver && !task.has_reviewer) ||
      (completionStep.status == 'not_started')
    )
  );
}

export default {
  canUserEditPhoto,
};



// WEBPACK FOOTER //
// ./src/helpers/permissions/PhotoPermissionsUtil.js